import React from 'react';
import { Container } from 'react-bootstrap';
import Button from '../../../../components/Button';
import BaseLifeInsuranceModal from './BaseLifeInsuranceModal';

const BaseLifeInsuranceModalDemo = () => {
  const [showBaseLifeInsuranceModal, setShowBaseLifeInsuranceModal] =
    React.useState<boolean>(false);

  const handleShowBaseLifeInsuranceModal = () =>
    setShowBaseLifeInsuranceModal(true);
  const handleCloseBaseLifeInsuranceModal = () =>
    setShowBaseLifeInsuranceModal(false);

  return (
    <Container>
      <Container className="mt-10">
        <h4>Base Life Insurance Modal</h4>
        <Button onMouseDown={handleShowBaseLifeInsuranceModal}>
          Open Modal
        </Button>
        <BaseLifeInsuranceModal
          showBaseLifeInsuranceModal={showBaseLifeInsuranceModal}
          handleCloseBaseLifeInsuranceModal={handleCloseBaseLifeInsuranceModal}
        />
      </Container>
    </Container>
  );
};

export default BaseLifeInsuranceModalDemo;
